/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import Form from '../../../components/Form';
import Modal, { ModalHeader } from '../../../components/Modal';
import useForm from '../../../hooks/useForm';
import { dateToFormat, diffDays, getDay, getFutureDay } from '../../../utils/date';
import { viewLoading } from '../../../utils/loading';
import systemAlert from '../../../utils/systemAlert';
import { toast } from '../../../utils/toast';
import { TAX_SINGO_SCRAPING_TYPE_LIST } from '../../../constants/TaxPortal/TAX_SINGO';
import { taxSingoWetaxResultsFetch } from '../../../apis/tax-portal/tax-singo/tax-singo';

const TaxSingoWetaxScrapingModal = ({
  isOpen,
  setIsOpen,
  submit,
  scheduled,
  singoType,
  reload,
}) => {
  const [fields] = useState([
    // {
    //   title: '세목',
    //   key: 'taxItem',
    //   type: 'select',
    //   options: {
    //     list: TAX_SINGO_SCRAPING_TYPE_LIST
    //   },
    //   required: true
    // },
    {
      title: '조회기간',
      key: 'date',
      type: 'customdatepicker',
      required: true,
    }
  ]);

  const _submit = (form) => {

    const fromDate = dateToFormat(form.date[0], 'YYYYMMDD');
    const toDate = dateToFormat(form.date[1], 'YYYYMMDD');
    const maxDate = getFutureDay(4, 'YYYYMMDD', fromDate);
    if (diffDays(maxDate, toDate) > 0) return toast.error('조회 기간은 최대 5일 입니다.');

    viewLoading('스크래핑중입니다. 잠시만기다려주세요. 몇분 걸릴 수도 있습니다.');

    taxSingoWetaxResultsFetch({
      scheduledIdx: scheduled.idx,
      fromDate,
      toDate,
      taxItem: form.taxItem
    })
      .then(() => {
        systemAlert(
          <>
            <p>스크래핑 요청에 성공하였습니다.</p>
          </>
        );
        cancel();
        reload();
      })
      .finally(() => {
        viewLoading(false);
      });

  };

  const {
    form,
    errors,
    handleSubmit,
    handleOnChange,
  } = useForm(
    {
      taxItem: TAX_SINGO_SCRAPING_TYPE_LIST?.find((t) => t.label === singoType)?.wetaxItem,
      date: [getDay(), getDay()]
    },
    _submit
  );


  const cancel = () => {
    setIsOpen(false);
  };

  return (
    <Modal size="md" isOpen={isOpen} close={cancel}>
      <div className="passivity-scraping-wrap">
        <ModalHeader>
          {singoType} 신고내역 위택스 스크래핑
          <p className="sub-title">조회기간을 최대 5일 이내로 설정해주세요.</p>
          <p className="sub-title">수집중 페이지를 이탈하지말아주세요.</p>
          <br />
          <p className="sub-title color-red-100">지정된 기간내에 해당 위택스 아이디로 신고한 전체 정보를 가져옵니다.</p>
          <p className="sub-title color-red-100">중복된 요청은 피해주세요.</p>
          <p className="sub-title">('Wecake T 관리 - 위택스 설정' 정보 필요)</p>
          <br />
          <p className="sub-title">"{scheduled.name}"의 정보만 업데이트 됩니다.</p>
        </ModalHeader>
        <Form
          fields={fields}
          form={form}
          onChange={handleOnChange}
          submit={handleSubmit}
          submitText={'수집하기'}
          cancel={cancel}
          errors={errors}
        />
      </div>
    </Modal>
  );
};

export default TaxSingoWetaxScrapingModal;